import { useQuery } from "@tanstack/react-query";
import newArtistsClient, {
  NEW_ARTISTS_SUBMISSIONS_QUERY_KEY,
} from "../../../api/new-artists";

const useNewArtistsContactSubmissionsQuery = () => {
  return useQuery({
    queryKey: NEW_ARTISTS_SUBMISSIONS_QUERY_KEY,
    queryFn: () => newArtistsClient.getSubmissions(),
    staleTime: 60_000,
  });
};

export default useNewArtistsContactSubmissionsQuery;
